import React from 'react'

const ChatReportDialog = ({lang, msg, type, value}) => {
  function showDialogTitle() {
    if (type === 'report' && value === 0) {
      return lang?.common?.are_you_sure_you_want_to_report;
    } else if (type === 'report' && value === 1) {
      return lang?.common?.are_you_sure_you_want_to_unreport;
    } else if (type === 'block' && value === 0) {
      return lang?.common?.are_you_sure_you_want_to_block;
    } else if (type === 'block' && value === 1) {
      return lang?.common?.are_you_sure_you_want_to_unblock;
    }
  }
  return (
    <div className='!z-[1000] px-[24px] pt-[20px]'>
      <div className='flex items-center justify-between'>
        <div className='text-[20px] text-black'>
          {showDialogTitle()}
        </div>
        {/*  <MdClose size={20} /> */}
      </div>
      <div className='mt-4 flex text-sm'>{msg}</div>
    </div>
  );
}

export default ChatReportDialog